import { Box } from '@mui/material';
import TransactionItems from './transaction-item/transaction-items.component';

const TransactionItemInformation = ({ checks }) => {
  return (
    <Box
      mt={4}
      data-testid="TransactionDetailsDrawer.TransactionItemInformation"
    >
      {checks?.length > 0 &&
        checks.map(check =>
          check.orderItems.map(orderItem => (
            <TransactionItems
              key={`${check.checkId}-${orderItem.extItemId}`}
              {...orderItem}
            />
          )),
        )}
    </Box>
  );
};

export default TransactionItemInformation;
